import { request } from '../../request';
import { filterToQueryParams } from '../../utils';
import dayjs from 'dayjs';
import { TIMEZONE_FALLBACK } from '@libs/config';
import { FiltersCollection } from '@libs/store/filters';

const FallbackTimezone = TIMEZONE_FALLBACK;

export async function getAssignments(
  startDate: string,
  endDate: string,
  timezone: string,
  filters: FiltersCollection = {},
) {
  const applyFilters = filterToQueryParams(filters);
  const response = await request.get<{ staffId: string; shiftId: string }[]>('/v2/calendar/assignments', {
    params: {
      startDate: dayjs(startDate).toServerFilterDate(),
      endDate: dayjs(endDate).toServerFilterDate(),
      timeZone: timezone || FallbackTimezone,
    },
  });
  return response;
}
